import type { CommunityGroup } from '@communities/community-groups/domain';
import { routes } from '@communities/routes';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDeleteCommunityGroup } from './useDeleteCommunityGroup';

/**
 * Custom hook to manage delete community group dialog state and actions
 */
export function useDeleteCommunityGroupDialog(communityGroup: CommunityGroup | null) {
  const navigate = useNavigate();
  const { deleteCommunityGroup, loading: isDeleting, errors: deleteErrors, resetErrors } = useDeleteCommunityGroup();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDeleteSuccess = () => {
    setIsDeleteDialogOpen(false);
    navigate(routes.communityGroups.root);
  };

  const handleDeleteConfirm = async () => {
    if (!communityGroup) return;

    resetErrors();
    const success = await deleteCommunityGroup(communityGroup.id);

    if (success) {
      handleDeleteSuccess();
    }
  };

  const handleDeleteClose = () => {
    setIsDeleteDialogOpen(false);
    resetErrors();
  };

  const openDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  return {
    isDeleteDialogOpen,
    isDeleting,
    deleteErrors,
    openDeleteDialog,
    handleDeleteConfirm,
    handleDeleteClose,
  };
}
